<script>
	function processConfig(config, index = 0, rootListeners = {}) {
		let formattedProps = {}
		const {
			component = 'FormRenderer',
			children = null,
			depth = 1,
			attrs = {},
			class: styleClass = {},
		} = config;

		if (component === 'FormRenderer') {
			// structure props properly
			// formattedProps = {
			// 	fieldType: config.fieldType,
			// 	componentProps: config.props,
			// 	extraProps: config.extraProps,
			// 	validation: config.validation,
			// 	dataKey: config.dataKey,
			// 	providerProps: config.providerProps,
			// 	// value: '',
			// }
			if( !config.extraProps ) config.extraProps = {};
			formattedProps = {...config, ...config.settings}; // field settings need to come in at the parent level
		} else if (Object.prototype.hasOwnProperty.call(config, 'props')) {
			formattedProps = config.props
		}

		if( !formattedProps.componentProps )
			formattedProps.componentProps = {};

		const els = Array.isArray(children)
			? children.map((child) => Object.assign(child, {depth: depth + 1}))
			: children;

		return Object.assign(
			{component, props: formattedProps, depth, attrs, styleClass},
			els ? {children: els} : {}
		)
	}

	function tree(h, schema, rootListeners) {
		if (Array.isArray(schema)) {
			return schema.map((config, index) => {
				const item = processConfig(config, index, rootListeners)

				// hack to get around no nuxt
				if( item.component === 'v-row-dense') {
					item.component = 'div';
					item.styleClass['row row--dense'] = true;
				}
				if( item.component === 'v-row') {
					item.component = 'div';
					item.styleClass['row'] = true;
				}
				if( item.component === 'v-col' ) {
					item.component = 'div';
					item.styleClass['col'] = true;
					Object.keys(item.props).forEach((key) => {
						if( key === 'cols' ) {
							item.styleClass['col-'+item.props[key]] = true;
						} else {
							item.styleClass['col-'+key+'-'+item.props[key]] = true;
						}
					});
				}

				return h(
					item.component,
					{
						props: item.props,
						attrs: item.attrs,
						class: item.styleClass,
						on:rootListeners,
					},
					config.children ? tree(h, config.children, rootListeners) : null
				)
			})
		}

		return schema
	}

	export default {
		name: 'SchemaRenderer',
		functional: true,
		render: (h, {props, listeners}) => {
			return tree(h, props.schema, listeners);
		}
	}
</script>
